/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetPublicOrganizationsResponse } from '../../models/get-public-organizations-response';

export interface GetPublicOrganizations$Params {
}

export function getPublicOrganizations(http: HttpClient, rootUrl: string, params?: GetPublicOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<GetPublicOrganizationsResponse>> {
  const rb = new RequestBuilder(rootUrl, getPublicOrganizations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetPublicOrganizationsResponse>;
    })
  );
}

getPublicOrganizations.PATH = '/public/organizations';
